import React from 'react';
import LiveChatPage from '../../live-chat/pages/LiveChatPage';

const AgentLiveChatPage = ({ session = {} }) => (
  <LiveChatPage session={session} mode="agent" />
);

export default AgentLiveChatPage;
